import { render, staticRenderFns } from "./ProductCategoryCompany.vue?vue&type=template&id=3e33095c&scoped=true&"
import script from "./ProductCategoryCompany.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryCompany.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryCompany.vue?vue&type=style&index=0&id=3e33095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e33095c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
